// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hoofdak-extra{margin-top:40px}.map-image{vertical-align:text-bottom}", "",{"version":3,"sources":["webpack://./src/components/questionnaireExtra/questionnaire-extra.scss"],"names":[],"mappings":"AAAA,eACE,eAAA,CAEF,WACE,0BAAA","sourcesContent":[".hoofdak-extra {\n  margin-top: 40px;\n}\n.map-image {\n  vertical-align: text-bottom;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
